import React, { useState, useEffect, useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import { apiGet, apiPost, apiPatch } from '../services/api';

const ST = {
  abierto:    { label: 'Abierto',    bg: '#fef9c3', fg: '#92400e' },
  respondido: { label: 'Respondido', bg: '#dcfce7', fg: '#166534' },
  cerrado:    { label: 'Cerrado',    bg: '#e2e8f0', fg: '#475569' },
};
const fmtDT = s => { if (!s) return '—'; const d = new Date(String(s).replace(' ', 'T')); return isNaN(d) ? '—' : d.toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }); };
const fmtEur = n => (n == null || n === '') ? null : Number(n).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

const card   = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, marginBottom: 12 };
const inp    = { width: '100%', padding: '9px 11px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, marginBottom: 10, boxSizing: 'border-box', fontFamily: 'inherit' };
const lbl    = { fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 4 };
const btn    = (bg, c) => ({ background: bg, color: c, border: c === '#fff' ? 'none' : `1px solid ${c}`, borderRadius: 8, padding: '9px 15px', fontWeight: 700, fontSize: 13, cursor: 'pointer' });
const badge  = st => ({ fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 999, background: (ST[st] || ST.cerrado).bg, color: (ST[st] || ST.cerrado).fg });

function StatusBadge({ status }) { return <span style={badge(status)}>{(ST[status] || {}).label || status}</span>; }

export default function TicketsPage() {
  const { auth } = useContext(AuthContext);
  const token = auth.token;
  const isSuper = auth.user?.role === 'superadmin';

  const [tickets, setTickets] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [creating, setCreating] = useState(false);

  const load = useCallback(() => {
    apiGet('/tickets', token).then(d => setTickets(Array.isArray(d) ? d : [])).catch(() => setTickets([]));
  }, [token]);
  useEffect(() => { load(); }, [load]);

  if (openId) return <TicketDetail id={openId} token={token} isSuper={isSuper} onBack={() => { setOpenId(null); load(); }} />;

  return (
    <div style={{ maxWidth: 820, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22 }}>Soporte</h1>
          <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 13 }}>
            {isSuper ? 'Tickets de todas las empresas.' : 'Abre un ticket y te responderemos por aquí.'}
          </p>
        </div>
        {!isSuper && <button style={btn('#E84300', '#fff')} onClick={() => setCreating(true)}>+ Nuevo ticket</button>}
      </div>

      {creating && !isSuper && (
        <NewTicketForm token={token} onClose={() => setCreating(false)} onCreated={() => { setCreating(false); load(); }} />
      )}

      {tickets === null ? <p style={{ color: '#94a3b8' }}>Cargando…</p>
        : tickets.length === 0 ? <div style={{ ...card, color: '#94a3b8', textAlign: 'center' }}>No hay tickets todavía.</div>
        : tickets.map(t => (
          <div key={t.id} style={{ ...card, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }} onClick={() => setOpenId(t.id)}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 3 }}>{t.subject}</div>
              <div style={{ fontSize: 12, color: '#94a3b8' }}>
                {isSuper && <b style={{ color: '#475569' }}>{t.tenant_name || 'Empresa'} · </b>}
                {t.msg_count} mensaje(s) · Actualizado {fmtDT(t.updated_at)}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
              {fmtEur(t.price) && <span style={{ fontWeight: 700, color: '#0f766e', fontSize: 14 }}>{fmtEur(t.price)}</span>}
              <StatusBadge status={t.status} />
            </div>
          </div>
        ))}
    </div>
  );
}

function NewTicketForm({ token, onClose, onCreated }) {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function submit() {
    if (!subject.trim()) { setErr('El asunto es obligatorio'); return; }
    if (!body.trim())    { setErr('Escribe el mensaje'); return; }
    setBusy(true); setErr('');
    try { await apiPost('/tickets', { subject: subject.trim(), body: body.trim() }, token); onCreated(); }
    catch (e) { setErr(e.message); setBusy(false); }
  }

  return (
    <div style={{ ...card, background: '#f8fafc' }}>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>Nuevo ticket</div>
      <label style={lbl}>Asunto</label>
      <input style={inp} value={subject} onChange={e => setSubject(e.target.value)} placeholder="Resume tu consulta" />
      <label style={lbl}>Mensaje</label>
      <textarea style={{ ...inp, minHeight: 120, resize: 'vertical' }} value={body} onChange={e => setBody(e.target.value)} placeholder="Cuéntanos con detalle qué necesitas…" />
      {err && <p style={{ color: '#dc2626', fontSize: 13, margin: '0 0 10px' }}>{err}</p>}
      <div style={{ display: 'flex', gap: 8 }}>
        <button style={btn('#16a34a', '#fff')} onClick={submit} disabled={busy}>{busy ? 'Enviando…' : 'Enviar ticket'}</button>
        <button style={btn('#fff', '#64748b')} onClick={onClose} disabled={busy}>Cancelar</button>
      </div>
    </div>
  );
}

function TicketDetail({ id, token, isSuper, onBack }) {
  const [ticket, setTicket] = useState(null);
  const [reply, setReply] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [price, setPrice] = useState('');

  const load = useCallback(() => {
    apiGet(`/tickets/${id}`, token).then(t => { setTicket(t); setPrice(t.price == null ? '' : String(t.price)); }).catch(() => setTicket(false));
  }, [id, token]);
  useEffect(() => { load(); }, [load]);

  async function sendReply() {
    if (!reply.trim()) return;
    setBusy(true); setErr('');
    try { await apiPost(`/tickets/${id}/messages`, { body: reply.trim() }, token); setReply(''); load(); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  }

  async function savePrice() {
    setBusy(true); setErr('');
    try { await apiPatch(`/tickets/${id}`, { price: price === '' ? null : price }, token); load(); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  }

  async function setStatus(status) {
    setBusy(true); setErr('');
    try { await apiPatch(`/tickets/${id}`, { status }, token); load(); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  }

  if (ticket === null) return <p style={{ color: '#94a3b8' }}>Cargando…</p>;
  if (ticket === false) return <div><button style={btn('#fff', '#64748b')} onClick={onBack}>← Volver</button><p>Ticket no encontrado.</p></div>;

  return (
    <div style={{ maxWidth: 820, margin: '0 auto' }}>
      <button style={{ ...btn('#fff', '#64748b'), marginBottom: 14 }} onClick={onBack}>← Volver</button>

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <div>
            <h2 style={{ margin: '0 0 4px', fontSize: 19 }}>{ticket.subject}</h2>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>
              {isSuper && <b style={{ color: '#475569' }}>{ticket.tenant_name || 'Empresa'} · </b>}
              Abierto {fmtDT(ticket.created_at)}
            </div>
          </div>
          <StatusBadge status={ticket.status} />
        </div>

        {/* Precio (visible para todos; editable solo superadmin) */}
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #f1f5f9' }}>
          {isSuper ? (
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
              <div>
                <label style={lbl}>Precio (€)</label>
                <input style={{ ...inp, width: 160, marginBottom: 0 }} type="number" step="0.01" value={price} onChange={e => setPrice(e.target.value)} placeholder="Sin precio" />
              </div>
              <button style={btn('#0f766e', '#fff')} onClick={savePrice} disabled={busy}>Guardar precio</button>
              {ticket.status !== 'cerrado'
                ? <button style={btn('#fff', '#475569')} onClick={() => setStatus('cerrado')} disabled={busy}>Cerrar ticket</button>
                : <button style={btn('#fff', '#16a34a')} onClick={() => setStatus('respondido')} disabled={busy}>Reabrir</button>}
            </div>
          ) : (
            fmtEur(ticket.price)
              ? <div style={{ fontSize: 14 }}>Precio del soporte: <b style={{ color: '#0f766e' }}>{fmtEur(ticket.price)}</b></div>
              : <div style={{ fontSize: 13, color: '#94a3b8' }}>Sin precio asignado todavía.</div>
          )}
        </div>
      </div>

      {/* Hilo */}
      <div style={{ marginBottom: 12 }}>
        {(ticket.messages || []).map(m => {
          const mine = (m.author_role === 'superadmin') === isSuper;
          return (
            <div key={m.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
              <div style={{ maxWidth: '78%', background: m.author_role === 'superadmin' ? '#eef2ff' : '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '10px 14px' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: m.author_role === 'superadmin' ? '#4f46e5' : '#475569', marginBottom: 4 }}>
                  {m.author_name || (m.author_role === 'superadmin' ? 'Soporte' : 'Admin')}
                  {m.author_role === 'superadmin' && ' · Soporte'}
                  <span style={{ fontWeight: 400, color: '#94a3b8' }}> · {fmtDT(m.created_at)}</span>
                </div>
                <div style={{ fontSize: 14, color: '#1e293b', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{m.body}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Responder */}
      {ticket.status === 'cerrado' ? (
        <div style={{ ...card, color: '#94a3b8', textAlign: 'center' }}>Este ticket está cerrado.</div>
      ) : (
        <div style={card}>
          <label style={lbl}>{isSuper ? 'Responder al cliente' : 'Responder'}</label>
          <textarea style={{ ...inp, minHeight: 90, resize: 'vertical' }} value={reply} onChange={e => setReply(e.target.value)} placeholder="Escribe tu mensaje…" />
          {err && <p style={{ color: '#dc2626', fontSize: 13, margin: '0 0 10px' }}>{err}</p>}
          <button style={btn('#E84300', '#fff')} onClick={sendReply} disabled={busy || !reply.trim()}>{busy ? 'Enviando…' : 'Enviar'}</button>
        </div>
      )}
    </div>
  );
}
